import { useMemo } from 'react';
import { orderSkills, SkillOrServiceItem } from '../../utils/orderTags/orderSkills';

export const useOrderedSkills = <T extends SkillOrServiceItem>(skills: T[], roleId?: string | null) =>
    useMemo(() => orderSkills(skills, roleId), [roleId, skills]);
